import { documentationActions } from '../../actions/constant';

const {
  SUCCESS_GET_TARGET_SIGNATURE_ACCESS,
  FAILURE_GET_TARGET_SIGNATURE_ACCESS,
  REQUEST_GET_TARGET_SIGNATURE_ACCESS,
  RESET_GET_TARGET_SIGNATURE_ACCESS,
} = documentationActions;

//  BRK-2074: need-supervision maps ({t1, t2}) for the on-behalf-create TARGET. A separate
//  reducer from getSignatureAccessReducer on purpose: that one is fetched once at profile load
//  for the CALLER and read by every legacy create surface — a compliance flow must never
//  overwrite it. Reset whenever the target dialog opens or the target changes.
const intitialstate: object = {
  response: null,
  isGetAccess: false,
  isError: false,
  loading: false,
};

export const getTargetSignatureAccessReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_TARGET_SIGNATURE_ACCESS: {
      return {
        ...state,
        isGetAccess: true,
        isError: false,
        response: action.payload,
        loading: false,
      };
    }

    //  isError is an explicit failure signal: consumers WAIT on response.data (the maps), and a
    //  failure payload carries no .data — without the flag they would wait forever.
    case FAILURE_GET_TARGET_SIGNATURE_ACCESS:
      return {
        ...state,
        isGetAccess: false,
        isError: true,
        response: action.payload,
        loading: false,
      };

    case REQUEST_GET_TARGET_SIGNATURE_ACCESS:
      return {
        ...state,
        loading: true,
        isError: false,
      };

    case RESET_GET_TARGET_SIGNATURE_ACCESS:
      return intitialstate;

    default:
      return state;
  }
};
